import { render, staticRenderFns } from "./EditarPosto.vue?vue&type=template&id=5656b8fa&"
import script from "./EditarPosto.vue?vue&type=script&lang=js&"
export * from "./EditarPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports